import React from "react";
import ControlCard from "./ControlCard";
import { useUI } from "../../context/UIContext";

export default function ControlsView({ servers, pm2Servers = [], actions, searchTerm = "" }) {
  const { audit } = useUI();
  const term = searchTerm.trim().toLowerCase();
  const list = Object.values(servers).filter((sv) => {
    if (!term) return true;
    const code = (sv.ServerCode || "").toLowerCase();
    const name = (sv.ServerName || "").toLowerCase();
    const ip = (sv.IP || "").toLowerCase();

    const hasMatchingApp = (sv.apps || []).some((app) =>
      (app.appName || "").toLowerCase().includes(term)
    );

    const pm2Srv = pm2Servers.find((s) => s.serverCode === sv.ServerCode);
    const hasMatchingPm2 = pm2Srv && (pm2Srv.processes || []).some((p) =>
      (p.name || "").toLowerCase().includes(term)
    );

    return (
      code.includes(term) ||
      name.includes(term) ||
      ip.includes(term) ||
      hasMatchingApp ||
      hasMatchingPm2
    );
  });

  return (
    <div>
      {/* Cards Grid */}
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(430px, 1fr))",
        gap: "16px",
        marginBottom: "20px",
      }}>
        {list.length === 0 ? (
          <div style={{ gridColumn: "1 / -1" }}>
            <div className="empty-state">Chưa có server nào...</div>
          </div>
        ) : (
          list.map((sv) => (
            <ControlCard key={sv.ServerCode} sv={sv} actions={actions} />
          ))
        )}
      </div>

      {/* Audit Log Panel */}
      <div style={{
        borderRadius: "14px",
        background: "var(--surface)",
        border: "1px solid var(--border)",
        overflow: "hidden",
      }}>
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "9px",
          padding: "13px 18px",
          borderBottom: "1px solid var(--border)",
        }}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="var(--dim)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 8v4l3 3"></path>
            <circle cx="12" cy="12" r="9"></circle>
          </svg>
          <span style={{ fontSize: "13px", fontWeight: 700, color: "var(--text)" }}>Audit log</span>
          <span style={{ marginLeft: "auto", fontSize: "11.5px", color: "var(--faint)", fontFamily: "var(--font-mono)" }}>last 24h</span>
        </div>
        
        <div style={{ padding: "6px 0" }}>
          {audit.length === 0 ? (
            <div style={{
              padding: "14px 18px",
              fontSize: "12.5px",
              fontFamily: "var(--font-mono)",
              color: "var(--faint)",
              textAlign: "center",
            }}>
              Chưa có nhật ký hoạt động điều khiển nào trong phiên này.
            </div>
          ) : (
            audit.slice().reverse().map((e) => (
              <div
                key={e.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  padding: "9px 18px",
                  fontFamily: "var(--font-mono)",
                  fontSize: "12.5px",
                }}
              >
                <span style={{
                  width: "7px",
                  height: "7px",
                  borderRadius: "50%",
                  background: e.color || "var(--dim)",
                }}></span>
                <span style={{ color: "var(--faint)" }}>{e.t}</span>
                <span style={{ color: "var(--dim)" }}>admin</span>
                <span style={{ color: e.color || "var(--text)", fontWeight: 600 }}>{e.action}</span>
                <span style={{ color: "var(--text)" }}>{e.srv}</span>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
